import { CreateUserRequest } from "@/data/dtos/requests";
import { z } from "zod";

export const CreateUserRequestSchema: z.ZodType<CreateUserRequest> = z.object({
  name: z.string().min(3, "Informe um nome válido"),
  email: z.email("Informe um email válido"),
  country_code: z.string().min(1),
  phone: z.string().min(1, "Informe um telefone válido"),
  document_number: z.string().min(1, "Informe um documento ou CPF válido"),
  document_valid: z.literal(true, {
    error: "Informe um documento ou CPF válido",
  }),
  foreigner: z.boolean().optional(),
  password: z.string().min(8, "A senha deve ter no mínimo 8 caracteres"),
});
